import { useRef } from 'react';
import {
	AlertDialog,
	AlertDialogBody,
	AlertDialogContent,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogOverlay,
	Button
} from '@chakra-ui/react';

type ConfirmarExclusaoProps = {
	isOpen: boolean;
	onClose: () => void;
	onConfirmar: () => void;
	titulo: string;
	descricao: string;
};

/**
 * Confirmacao para as acoes destrutivas dos drawers. O foco inicial vai para
 * Cancelar (leastDestructiveRef), entao um Enter distraido nao apaga registro.
 */
export const ConfirmarExclusao = ({ isOpen, onClose, onConfirmar, titulo, descricao }: ConfirmarExclusaoProps) => {
	const cancelarRef = useRef<HTMLButtonElement>(null);

	return (
		<AlertDialog isOpen={isOpen} leastDestructiveRef={cancelarRef} onClose={onClose} isCentered>
			<AlertDialogOverlay>
				<AlertDialogContent>
					<AlertDialogHeader fontSize="lg" fontWeight="bold">
						{titulo}
					</AlertDialogHeader>
					<AlertDialogBody>{descricao}</AlertDialogBody>
					<AlertDialogFooter>
						<Button ref={cancelarRef} onClick={onClose}>
							Cancelar
						</Button>
						<Button colorScheme="red" ml={3} onClick={onConfirmar}>
							Excluir
						</Button>
					</AlertDialogFooter>
				</AlertDialogContent>
			</AlertDialogOverlay>
		</AlertDialog>
	);
};
